module.exports = __webpack_public_path__ + "img/icon-config.c9e652cc.svg";